import "./lookup.js";
import "./orderTypeWizard.js";
import "./detailsTab.js";
import "./details.js";
import "./packagingTab.js";
import "./reviewTab.js";



// WEBPACK FOOTER //
// ./src/pages/orderType/index.js